import React from "react";
import { useStateProvider } from "../common/StateProvider";
import { profileContactLogMeetingData } from "../common/Helper";
import AttachFileModal from "../common/AttachFileModal";

const ProfileContactLogMeeting = () => {
  const { profileAttachFileModal, setprofileAttachFileModal } =
    useStateProvider(); //ATTACH FILE MODAL

  // Function to show the Attach File MODAL
  const openMeetingAttachFileModal = () => {
    setprofileAttachFileModal(true);
  };
  return (
    <>
      <div className=" pb-[50px] h-full flex flex-col relative">
        <div>
          {profileContactLogMeetingData.map((value, index) => (
            <div
              className="w-[600px] md:w-auto p-[16px_20px] rounded-md bg-[#F6F6F6] hover:shadow-workflow_item_card_shadow duration-300 mb-[10px]"
              key={index}>
              <div className="flex justify-between items-center">
                <p className="text-[14px] font-normal text-black">
                  {value.meetingHeading}
                </p>
                <button
                  onClick={openMeetingAttachFileModal}
                  className="text-[10px] 3xl:text-[14px] font-medium text-primary rounded-[36px] border border-solid border-primary p-[4px_10px] hover:bg-primary hover:text-white hover:border-transparent duration-200">
                  + Attach File
                </button>
              </div>

              <div className="flex gap-12 pt-1">
                <div>
                  <p className="text-xs 3xl:text-[14px] font-normal text-gray opacity-60 ">
                    Date:
                  </p>
                  <p className="text-xs 3xl:text-[14px] font-normal text-black opacity-60 pt-1">
                    {value.meetingFullDate}
                  </p>
                </div>
                <div>
                  <p className="text-xs 3xl:text-[14px] font-normal text-gray opacity-60 ">
                    Time
                  </p>
                  <p className="text-xs 3xl:text-[14px] font-normal text-black opacity-60 pt-1">
                    {value.meetingTime}
                  </p>
                </div>
                <div>
                  <p className="text-xs 3xl:text-[14px] font-normal text-gray opacity-60">
                    Note
                  </p>
                  <p className="text-xs font-normal text-black pt-1 opacity-60">
                    {value.meetingNote}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="fixed top-[25%] right-0 md:right-[14%] lg:right-[11%] xl:right-[8%] z-[9999] 3xl:top-[33%] 3xl:right-[6%]">
          {profileAttachFileModal && (
            <AttachFileModal
              attachFileModal={profileAttachFileModal}
              setAttachFileModal={setprofileAttachFileModal}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ProfileContactLogMeeting;
